import { render, staticRenderFns } from "./search-customerinvoice.vue?vue&type=template&id=40b60972&"
import script from "./search-customerinvoice.vue?vue&type=script&lang=js&"
export * from "./search-customerinvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports